import styled from "styled-components";

const ContSelect = styled.div`
    width: 100%;
    position: relative;
`;

const SelectCustom = styled.div`
    width: 100%;
    height: 40px;
    background: #FFFFFF;
    border: 1px solid #E0E0E0;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 15px;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
        border-color: #7367f0;
    }
`;

const Text = styled.p`
    font-size: ${props => props.size};
    font-weight: ${props => props.fw};
    color: ${props => props.cl};
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

const BtnShowOptions = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    color: #707070;
    transition: all 0.3s ease;
`;

const ContListOptions = styled.div`
    width: 100%;
    max-height: 0;
    overflow: hidden;
    background: #FFFFFF;
    border-radius: 8px;
    position: absolute;
    top: calc(100% + 5px);
    left: 0;
    z-index: 1000;
    transition: all 0.3s ease;
    box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%);
    opacity: 0;
    visibility: hidden;

    ${props => props.active && `
        max-height: 300px;
        opacity: 1;
        visibility: visible;
    `}
`;

const SearchBox = styled.div`
    padding: 8px 12px;
    border-bottom: 1px solid #E0E0E0;
    display: flex;
    align-items: center;
    gap: 8px;

    .search-icon {
        color: #707070;
        font-size: 18px;
    }

    input {
        border: none;
        outline: none;
        width: 100%;
        font-size: 14px;
        color: #707070;
        background: transparent;

        &::placeholder {
            color: #A0A0A0;
        }
    }
`;

const ListEnterprises = styled.div`
    max-height: 250px;
    overflow-y: auto;
    padding: 8px 0;

    &::-webkit-scrollbar {
        width: 4px;
    }

    &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
        background: #7367f0;
        border-radius: 4px;
    }
`;

const ItemListEnterprise = styled.div`
    padding: 8px 12px;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
        background: #7367f01a;
    }

    ${Text} {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
`;

const SelectEnterpriseStyle = {
    ContSelect,
    SelectCustom,
    Text,
    BtnShowOptions,
    ContListOptions,
    ListEnterprises,
    ItemListEnterprise,
    SearchBox
};

export default SelectEnterpriseStyle;